module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/g5l6T6/tc-custom/9781488020018.jpg?1728327053808",
      "alt": "This image is the cover for the book Tangled Destinies"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Tangled Destinies\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("From a "), _c('i', [_vm._v("New York Times–")]), _vm._v("bestselling author, a man fights to protect the woman he once loved and left behind.")]), _c('br'), _c('br'), _vm._v(" Saved from an abduction and unthinkable harm, Gabrielle Bennett owed her life to her rescuer. Marc Stephano, a stranger from the sketchy shadows of town, could’ve asked for money. Instead he introduced her to desire and claimed her completely—then he broke her heart."), _c('br'), _c('br'), _vm._v(" Older, wiser and now a top New York model, Gabrielle is prepared for anything—except Marc’s reemergence into her life. It’s a merciless trick of fate. A successful, self-made millionaire, he’s as powerful as ever, but can Gabrielle forgive and forget—in the name of love?"), _c('br'), _c('br'), _vm._v(" “Palmer proves that love and passion can be found even in the most dangerous situations.” —"), _c('i', [_vm._v("Publishers Weekly")]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Diana Palmer\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("The prolific author of more than one hundred books, Diana Palmer got her start as a newspaper reporter. A New York Times bestselling author and voted one of the top ten romance writers in America, she has a gift for telling the most sensual tales with charm and humor. Diana lives with her family in Cornelia, Georgia.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0